import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ResponseSummary  {
    _originalTypeClassName = "zERP.BO.ResponseSummary";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ResponseSummary.translate = translateService;
}
this.ErrorTypes = [];
this.SeriesAndAA = null;
this.ResponseSummaryKey = null;
this._key = this.ResponseSummaryKey = 0; 
}

static translate: TranslateService;
_key: any;
SeriesAndAA:any;
ErrorTypes:any;
private _ResponseSummaryKey:any;
get ResponseSummaryKey(): any {
    return this._ResponseSummaryKey;
  }
set ResponseSummaryKey(value: any) {
    this._ResponseSummaryKey = value;
    this._key = value;
  }
static setErrorTypes = ($this, items) => {
                if (items == null) items = [];
                if ($this.ErrorTypes == null) $this.ErrorTypes = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ErrorTypes.length > 0) {
                    Domain.ResponseSummary.removeErrorTypes($this, $this.ErrorTypes[0]);
                }

                Domain.ResponseSummary.addManyErrorTypes($this, copyItems);
            }
static addManyErrorTypes = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ResponseSummary.addErrorTypes($this, items[i]);
                }
            }
static addErrorTypes = ($this, item) => {
                if ($this.ErrorTypes == null) $this.ErrorTypes = [];
                if (item == null || $this.ErrorTypes.indexOf(item) > -1) return;
                $this.ErrorTypes.push(item);
}
static addRangeErrorTypes = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ResponseSummary.addErrorTypes($this, item));
            }
static removeErrorTypes = ($this, item) => {
                if ($this == null || $this.ErrorTypes == null || $this.ErrorTypes.indexOf(item) === -1) return;
                var _index = $this.ErrorTypes.indexOf(item);
                $this.ErrorTypes.splice(_index, 1);
}
static clearErrorTypes = ($this) => { $this.ErrorTypes = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ResponseSummaryKey == null || $this.ResponseSummaryKey == 0;
            }


}